import type { ProductStatus, ProductType } from "../../api/product";

/** One colour per status and per type, shared by the grid and the product page. */
export const STATUS_VARIANT: Record<ProductStatus, "success" | "warning" | "error" | "info"> = {
  AVAILABLE: "success",
  PENDING_LAUNCH: "info",
  PENDING_DISCONTINUED: "warning",
  DISCONTINUED: "error",
};

export const TYPE_VARIANT: Record<ProductType, "accent" | "info" | "neutral"> = {
  BUNDLE: "accent",
  SINGLE_ITEM: "info",
  COMPONENT: "neutral",
};
